module.exports = __webpack_public_path__ + "img/verification.a8cccb10.svg";